// google、facebook第三方登录提示

let language = {

    GOOGLE_BTN_CONNECTION_FAIL_TITLE: "Google 服务连接问题",
    GOOGLE_BTN_CONNECTION_FAIL_CONTENT: "我们需要在此页面使用Google服务，但您似乎无法连接到Google。"

};

export { language }